import React from "react";
import { Clock, Eye, MoreHorizontal } from "lucide-react";
import { Line, LineChart, ResponsiveContainer } from "recharts";
import type { Strategy } from "./types";

export function StrategyCard({ data }: { data: Strategy }) {
  const isProfit = data.profitValue > 0;
  const isLoss = data.profitValue < 0;

  const profitColorClass = isProfit
    ? "text-red-500"
    : isLoss
    ? "text-green-500"
    : "text-white";

  return (
    <div className="bg-[#0f1221] border border-gray-800 rounded-2xl p-5 hover:border-gray-600 transition-all duration-300 relative overflow-hidden group">
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-white text-lg font-medium">{data.title}</h3>
        <button type="button" className="text-gray-500 hover:text-white">
          <MoreHorizontal size={20} />
        </button>
      </div>

      <div className="h-16 w-full mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data.chartData}>
            <Line type="monotone" dataKey="value" stroke={data.chartColor} strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
           <div
            className={`text-3xl font-bold ${data.score >= 8 ? "text-red-500" : "text-green-500"}`}
          >
            {data.score}
          </div>
          <div className="text-xs text-gray-400 mt-1">Score</div>

        </div>
        <div>
           <div className={`text-2xl font-bold ${profitColorClass}`}>{data.profit}</div>
          <div className="text-xs text-gray-400 mt-1">Return</div>

        </div>
      </div>

      <div className="text-xs text-gray-500 mb-4">K-Quant AI strategy beta {data.version}</div>

      <div className="flex items-center justify-between text-xs">
        <span
          className={`px-3 py-1 rounded-full ${
            data.status === "online"
              ? "bg-blue-500/20 text-blue-400 border border-blue-500/30"
              : "bg-red-500/10 text-red-400 border border-red-500/30"
          }`}
        >
          {data.status === "online" ? "Online" : "Offline"}
        </span>

        <div className="flex items-center gap-4 text-gray-400">
          <div className="flex items-center gap-1">
            <Clock size={12} />
            {data.date}
          </div>
          <div className="flex items-center gap-1">
            <Eye size={12} />
            {data.views}
          </div>
        </div>
      </div>
    </div>
  );
}
